import React from "react"
import Layout from "../components/Layout.js"

export default ({ children }) => <Layout>{children}</Layout>
